import React from 'react'
import { Link } from 'react-router-dom'
import { COMPANY_INFO, NAV_LINKS } from '../lib/constants'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gradient-to-b from-[#141628] to-[#10111F] text-[#D9D9D5] border-t border-[#252B66]/60">
      {/* Main Footer Links */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-10">
          {/* Col 1: About Jakob */}
          <div className="space-y-4">
            <div className="flex items-center gap-2.5">
              <span className="font-extrabold text-2xl sm:text-3xl text-white tracking-tight">
                jakob<span className="text-[#E36C0A]">elektriker</span>.dk
              </span>
            </div>
            <p className="text-xs sm:text-sm text-[#9FA6D9] leading-relaxed">
              Grundig og altid smilende elektriker med 25 års erfaring for både private og erhverv. Specialiseret i liftarbejde med egne lifte og effektive kabeltræk.
            </p>
            <div className="pt-2 text-xs text-[#9FA6D9] space-y-1.5 border-t border-[#252B66]/60">
              <div><strong className="text-white font-medium">Timepris:</strong> 485,- ex moms inkl. servicevogn</div>
              <div><strong className="text-white font-medium">Kabelgravning:</strong> Private arealer – ring for tilbud</div>
              <div><strong className="text-white font-medium">Forsikring:</strong> Fuldt ud forsikret</div>
            </div>
          </div>

          {/* Col 2: Services */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white mb-4">
              Centrale ydelser
            </h4>
            <ul className="space-y-2.5 text-xs sm:text-sm">
              <li>
                <Link to="/el-arbejde" className="text-[#86878D] hover:text-white transition-colors flex items-center gap-2">
                  <span className="text-[#86878D] group-hover:text-white">›</span>
                  <span>Almindeligt el-arbejde</span>
                </Link>
              </li>
              <li>
                <Link to="/kabeltraek" className="text-[#86878D] hover:text-white transition-colors flex items-center gap-2">
                  <span className="text-[#86878D] group-hover:text-white">›</span>
                  <span>Lange kabeltræk</span>
                </Link>
              </li>
              <li>
                <Link to="/liftarbejde" className="text-[#86878D] hover:text-white transition-colors flex items-center gap-2">
                  <span className="text-[#86878D] group-hover:text-white">›</span>
                  <span>Liftarbejde (8m & 10,5m)</span>
                </Link>
              </li>
              <li>
                <Link to="/designerlamper" className="text-[#86878D] hover:text-white transition-colors flex items-center gap-2">
                  <span className="text-[#86878D] group-hover:text-white">›</span>
                  <span>Montering af designerlamper</span>
                </Link>
              </li>
              <li>
                <Link to="/erhverv" className="text-[#86878D] hover:text-white transition-colors flex items-center gap-2">
                  <span className="text-[#86878D] group-hover:text-white">›</span>
                  <span>Erhverv & Entreprenører</span>
                </Link>
              </li>
              <li>
                <Link to="/om-jakob" className="text-[#86878D] hover:text-white transition-colors flex items-center gap-2">
                  <span className="text-[#86878D] group-hover:text-white">›</span>
                  <span>Om Jakob & 25 års erfaring</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Specialized Equipment */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white mb-4">
              Eget udstyr & Pakker
            </h4>
            <ul className="space-y-2.5 text-xs sm:text-sm text-[#86878D]">
              <li className="flex items-start gap-2">
                <span className="w-1 h-1 rounded-full bg-[#E36C0A] mt-2 shrink-0" aria-hidden="true" />
                <span><strong className="text-white font-medium">Egen saxelift:</strong> 8m arbejdshøjde, kan gå gennem almindelig dør.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1 h-1 rounded-full bg-[#E36C0A] mt-2 shrink-0" aria-hidden="true" />
                <span><strong className="text-white font-medium">Mobil Omme bomlift:</strong> 10,5m højde, kan gå gennem en havelåge.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1 h-1 rounded-full bg-[#E36C0A] mt-2 shrink-0" aria-hidden="true" />
                <span><strong className="text-white font-medium">Kabelaftrækkersystem:</strong> På minilæsser, op til 3 kabler ad gangen.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1 h-1 rounded-full bg-[#E36C0A] mt-2 shrink-0" aria-hidden="true" />
                <span><strong className="text-white font-medium">Pakkeløsning:</strong> Saxelift, 1,5 km kabelaftrækker & elektriker.</span>
              </li>
            </ul>
          </div>

          {/* Col 4: Contact details */}
          <div className="space-y-3">
            <h4 className="text-xs font-bold uppercase tracking-widest text-white mb-4">
              Virksomhed & Kontakt
            </h4>
            <div className="text-xs sm:text-sm text-[#86878D] space-y-2.5">
              <div className="font-semibold text-white">{COMPANY_INFO.name}</div>
              <div className="flex items-start gap-2.5">
                <i className="fa-solid fa-location-dot text-[#86878D] mt-0.5 text-xs" aria-hidden="true" />
                <span>{COMPANY_INFO.address}<br />{COMPANY_INFO.postal} {COMPANY_INFO.city}</span>
              </div>
              <div className="flex items-center gap-2.5">
                <i className="fa-solid fa-id-card text-[#86878D] text-xs" aria-hidden="true" />
                <span>CVR: {COMPANY_INFO.cvr}</span>
              </div>
              <div className="flex items-center gap-2.5 pt-1">
                <i className="fa-solid fa-phone text-[#86878D] text-xs" aria-hidden="true" />
                <a
                  href={`tel:${COMPANY_INFO.phoneRaw}`}
                  className="font-bold text-white hover:text-[#E36C0A] transition-colors whitespace-nowrap"
                >
                  {COMPANY_INFO.phone}
                </a>
              </div>
              <div className="flex items-center gap-2.5">
                <i className="fa-regular fa-envelope text-[#86878D] text-xs" aria-hidden="true" />
                <a
                  href={`mailto:${COMPANY_INFO.email}`}
                  className="hover:text-white transition-colors whitespace-nowrap"
                >
                  {COMPANY_INFO.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom copyright and legal note - NO cookies / privacy policy per brief */}
        <div className="pt-8 mt-10 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#86878D]">
          <div>
            © {currentYear} {COMPANY_INFO.name} • CVR: {COMPANY_INFO.cvr} • Alle rettigheder forbeholdes.
          </div>
          <div>
            <span className="text-[#86878D]">Autorisationskrævende el-arbejde udføres i samarbejde med el-installatør</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
